import { r4Client, r4Error } from '@/services'

const DealerRooftopApi = {
  async fetchRooftops (dealerId) {
    try {
      const resp = await r4Client().get(`/api/v1/dealers/${dealerId}/rooftops`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async createRooftop (dealerId, dealerData) {
    try {
      const resp = await r4Client().post(`/api/v1/dealers/${dealerId}/rooftops`, dealerData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async updateRooftop (dealerId, rooftopData) {
    try {
      const resp = await r4Client().put(`/api/v1/dealers/${dealerId}/rooftops/${rooftopData.id}`, rooftopData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  // determines if create or update should be used
  async saveRooftop (dealerId, rooftopData) {
    if (rooftopData.id) {
      return this.updateRooftop(dealerId, rooftopData)
    } else {
      return this.createRooftop(dealerId, rooftopData)
    }
  },
  async getRooftop (dealerId, rooftopId) {
    try {
      const resp = await r4Client().get(`/api/v1/dealers/${dealerId}/rooftops/${rooftopId}`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default DealerRooftopApi
